export const SETTINGS_NAVIGATION = [
  { types: ["branding", "destination"], path: "branding", key: "branding", label: "Branding" },
  { types: ["inbox"], path: "messages", key: "messages", label: "Messaging Settings" },
  { types: ["chat"], path: "chat", key: "chat", label: "AI Chatbot & Text Webchat" },
  { types: ["house_rules"], path: "house-rules", key: "house_rules", label: "House Rules" },
  { types: ["integrations"], path: "integrations", key: "integrations", label: "Airbnb Integration" },
  { types: ["five_star"], path: "five-star", key: "five_star", label: "Five Star Review" },
  { types: ["tags"], path: "tags", key: "tags", label: "Tags" },
  {
    types: ["tags", "tag_groups"],
    path: "tag-groups",
    key: "tag_groups", label: "Tag Groups",
  },
  { types: ["destination"], path: "embed", key: "embed", label: "Embed" },
  {
    types: ["holiday_schedule"],
    path: "holiday-schedule",
    key: "holiday_schedule", label: "Holiday Schedule",
  },
  { types: ["integration", "custom_macros"], path: "api", key: "api", label: "API" },
  { types: [], path: "smart-locks", key: "smart_locks", label: "Smart Lock Settings" },
];
